import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { SharedService } from 'src/app/service/shared/shared.service';

@Component({
  selector: 'app-variable-pay-logs',
  templateUrl: './variable-pay-logs.component.html',
  styleUrls: ['./variable-pay-logs.component.scss'],
})
export class VariablePayLogsComponent  implements OnInit {
  buttonColorName:any
  selectedYear:any;
  getIncrementFyYearList:any = [];
  loggedInUserCompanyID:any;
  loggedInCompanyFiscalyear:any;
  fromYear:any;
  toYear:any;
  selectChangeType:any = "All";
  get_vplogsData:any = []

  gridData: {
    columnInfo: Array<{ label: string, propertyName: string, sortingName: string }>,
    columnData: Array<any>,
    totalCount: number,
    totalNoOfPages: number,
    showCheckBox: boolean
    showExportBtn: boolean,
    showGraphBtn: boolean
    showSearchBar: boolean,
    showAddBtn: boolean,
    currentPage: number,
    showDeleteBtn: boolean,
    tabsData: Array<any>,
    tabsMainData: Array<any>,
    showAccessConfigBtn: boolean,
    showTitle: boolean,
    showBreadCrumbs: boolean,
    showAuditLog: boolean,
    showPermantDeleteBtn: boolean,
    showRestoreBtn: boolean,
    showImportBtn: boolean,
    showBackBtn: boolean,
    showRefreshFunctinallity: boolean,
    countTabs: Array<any>,
  } = {
      columnInfo: [], columnData: [], totalCount: 0, totalNoOfPages: 0, showCheckBox: false, showExportBtn: false,
      showGraphBtn: false, showSearchBar: false, showAddBtn: false, currentPage: 0, showDeleteBtn: false,
      tabsData: [], tabsMainData: [], showAccessConfigBtn: false, showTitle: false, showBreadCrumbs: true,
      showAuditLog: true, showPermantDeleteBtn: false, showRestoreBtn: false, showImportBtn: false, showBackBtn: false,
      showRefreshFunctinallity: false, countTabs: []
    };


  constructor(private httpService: HttpService,private config: Config,private datePipe: DatePipe,public router: Router, 
    private activatedroute: ActivatedRoute,private encryptionService: EncryptionService,
    public sharedService: SharedService,) { }

  ngOnInit() {
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.activatedroute.params.subscribe((params: any) => {
      this.auditLogId = params?.id;
      this.auditLogModuleName = params?.moduleName;
      this.auditLogNumber = params?.code;
      // this.paginationUrl = this.config.getAllAuditLog + 'Observation' + '/' + this.observationID;
    });
  }

  ionViewWillEnter() {
    this.getIncrementFyYear();
  }
    
  onClickSetup() {
    this.router.navigate(['/home/hrportal/variablepay']);
  }

  getIncrementFyYear() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      
      this.getIncrementFyYearList = []
      data?.data?.yearRanges?.forEach((ele: any) => {
        const [start, end] = ele.split('_');
        this.getIncrementFyYearList.push({ year: `${start}-${end}` });
      });    
      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }   
      this.selectedYear = this.getIncrementFyYearList[selectedYearIndex]?.year;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      
    
      this.initilaizeColumn();
      this.getAuditLogsData();
    })
  }

  onYearChange(data:any){
    if(data){
      this.getAuditLogsData();
    }
  }

  onSelectChangeType(data:any){
    if(data){
      this.getAuditLogsData();
    }
  }

  isChangeDetected: boolean = false;
  currentPage: number = 1;
  auditLogId: any;
  auditLogModuleName:any;
  paginationUrl: any = '';
  showListingPage: boolean = true;
  auditLogNumber:any;
  subModuleButtonColor:any;
  page:any=0;


  initilaizeColumn() {
    this.gridData.columnInfo = [];
    this.gridData.columnInfo.push({label: 'Field', propertyName: 'fieldName',sortingName: 'columnName'});
    this.gridData.columnInfo.push({label: 'Old Value', propertyName: 'oldValue',sortingName: 'oldValue'});
    this.gridData.columnInfo.push({label: 'New Value', propertyName: 'newValue',sortingName: 'newValue'});
    this.gridData.columnInfo.push({label: 'Changed By', propertyName: 'lastModifiedBy',sortingName: 'lastModifiedBy'});
    this.gridData.columnInfo.push({label: 'Changed On', propertyName: 'updatedAt',sortingName: 'updatedAt'});
  }
  getAuditLogsData(){
    var type: string[] = [];
    
    if(this.selectChangeType == 'All'){
      type = ['Variable Pay Setup', 'Variable Pay Input']
    }else{
      type = [ this.selectChangeType ]
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "type": type,
      "year":  this.selectedYear
    }
    this.httpService.callPostService(this.config.get_vplogs + '?page=' + this.page+'&sort=' + this.sortName + ','+this.sortBy ,request).subscribe((res:any)=>{
      this.gridData.totalNoOfPages = res?.data?.totalPages;
      this.gridData.totalCount = res?.data?.total;
      this.gridData.currentPage = res?.data?.currentPageNumber;
      this.renderColumnData(res.data?.logs);
    },(error:any)=>{
      console.log(error)
    })
  }
  renderColumnData(logData:any){
    this.gridData.columnData = [];
    for (let i = 0; i < logData?.length; i++) {
      this.gridData.columnData.push({
          id: logData[i].id,
          fieldName: logData[i]?.columnName,
          oldValue: logData[i]?.oldValue,
          newValue: logData[i]?.newValue,
          lastModifiedBy: logData[i]?.firstName+' '+logData[i]?.lastName,
          updatedAt: this.datePipe.transform(logData[i]?.updatedAt,"dd MMM yyyy | hh:mm a"),
        });
    }
    this.isChangeDetected = !this.isChangeDetected
    this.mapRenderData();
  }
  renderData:any = [];
  mapRenderData() {
    this.renderData = [];
    for (let i = 0; i < this.gridData.columnData.length; i++) {
      var output = Object.entries(this.gridData.columnData[i]).map(([key, value]) => ({ key, value }));
      this.renderData.push(output);
    }
  }
  sortName:any='updatedAt';
  sortBy:any='desc'
  sortAsending(name:any){
    this.sortName=name;
    this.sortBy = 'asc';
    var type: string[] = [];
    
    if(this.selectChangeType == 'All'){
      type = ['Variable Pay Setup', 'Variable Pay Input']
    }else{
      type = [ this.selectChangeType ]
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "type": type,
      "year":  this.selectedYear
    }
    this.httpService.callPostService(this.config.get_vplogs + '?page=' + this.page+'&sort=' + this.sortName + ','+this.sortBy ,request).subscribe((res:any)=>{
      this.gridData.totalNoOfPages = res?.data?.totalPages;
      this.gridData.totalCount = res?.data?.total;
      this.gridData.currentPage = res?.data?.currentPageNumber;
      this.renderColumnData(res.data?.logs);
    },(error:any)=>{
      console.log(error)
    })
  }
  sortDesending(name:any){
    this.sortName = name;
    this.sortBy = 'desc';
    var type: string[] = [];
    
    if(this.selectChangeType == 'All'){
      type = ['Variable Pay Setup', 'Variable Pay Input']
    }else{
      type = [ this.selectChangeType ]
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "type": type,
      "year":  this.selectedYear
    }
    this.httpService.callPostService(this.config.get_vplogs + '?page=' + this.page+'&sort=' + this.sortName + ','+this.sortBy ,request).subscribe((res:any)=>{
      this.gridData.totalNoOfPages = res?.data?.totalPages;
      this.gridData.totalCount = res?.data?.total;
      this.gridData.currentPage = res?.data?.currentPageNumber;
      this.renderColumnData(res.data?.logs);
    },(error:any)=>{
      console.log(error)
    })
  }
  pageChange(response:any){
    this.currentPage = response.currentPageNumber - 1;
    this.renderColumnData(response.data.plant);
  }
  backbtn(){
    this.router.navigate(['/home/hrportal/employeemaster', { id: this.auditLogId, operation: 'Show' }]);
  }
  backbtnToListingpage(){
    this.router.navigate(['/home/hrportal/employeemaster']);
  }
  previousPage(){
    if(this.currentPage < 2){
      return;
    }else{
      this.currentPage--;
      this.page--;
      this.getAuditLogsData();
    }
  }
  nextPage(){
    if(this.currentPage >= this.gridData.totalNoOfPages){
      return;
    }
    if(this.currentPage==1){
      this.page=1;
    }else{
      this.page++;
    }
    this.currentPage++;
    this.getAuditLogsData();
  }
}
